import React, { Component } from "react";
import { connect } from "react-redux";
import ScrollToTopOnMount from "components/UI/ScrollToTopOnMount";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import Header from "components/Header/Header";
import HeaderContent from "components/Header/HeaderContent";
import HeaderSub from "components/Header/HeaderSub";
import Footer from "components/Footer";
import { withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
// import Bubble from 'components/UI/Bubble';
import BlockTitle from "components/UI/BlockTitle";
// import BlockButton from 'components/UI/BlockButton';
import HelpSpeedTest from "components/Help/HelpSpeedTest";
import Faq from "components/Faq";
import i18n from "helpers/i18n";
import { getCurrentUserRole } from "ducks/authentication";
import Grid from "@material-ui/core/Grid";
import Template from "components/Template/Template";

const styles = (theme) => {
  return {
    root: {
      minHeight: "100%",
      // height:'calc(100% - 105px)'
    },
    wrapper: {
      maxWidth: "1280px",
      margin: "0 auto",
      height: "100%",
      // background: 'linear-gradient(180deg, rgba(241,243,244,0.42) 0%, rgba(223,227,229,0.42) 100%)',
      borderBottom: "3px rgba(49,142,184,0.18) solid",
    },
    faq: {
      height: 680,
      [theme.breakpoints.down("sm")]: {
        height: "auto",
      },
    },
    // headerBg: {
    //   minHeight: 210,
    //   backgroundImage: `url(${require("assets/images/" +
    //     process.env.REACT_APP_SITE +
    //     "/header.jpg")})`,
    //   backgroundPosition: "0 0",
    //   [theme.breakpoints.down("sm")]: {
    //     backgroundImage: "none",
    //   },
    // },
    // bgSpacerTop: {
    //   backgroundRepeat: "no-repeat",
    //   backgroundPosition: "50% 50%",
    //   backgroundSize: "cover",
    //   height: 138,
    //   backgroundImage: `url(${require("assets/images/" +
    //     process.env.REACT_APP_SITE +
    //     "/halfcircle_top.png")})`,
    //   marginBottom: theme.spacing(10),
    //   [theme.breakpoints.down("sm")]: {
    //     height: 70,
    //     marginBottom: theme.spacing(3),
    //   },
    // },
  };
};
class Help extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // answerVisible: null,
      // speedTestPopin: false,
      // contactPopin: false
    };
  }

  render() {
    const { onPanelToggle, userRole, classes } = this.props;

    const isAdmin = userRole === "admin";

    return (
      <Template
        current={"help"}
        headerContent={
          process.env.REACT_APP_SITE === "psy" ? (
            <HeaderContent classes={classes} />
          ) : undefined
        }
      >
        <Box width="100%">
          <Box mb={3}>
            <Typography variant="h2" align="center">
              {i18n.get("helpTitle")}
            </Typography>
          </Box>
          <Box
            mb={5}
            px={3}
            className={classes.faq}
            display={"flex"}
            alignItems="flex-start"
            justifyContent="space-around"
            flexDirection="column"
          >
            <Faq isAdmin={isAdmin} userRole={userRole} forceOpen={true} />
          </Box>
          <Box mb={5} align="middle">
            <HelpSpeedTest style={{ padding: "20px 0" }} />
          </Box>
        </Box>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    userRole: getCurrentUserRole(state),
  };
  return props;
}

export default withStyles(styles)(connect(mapStateToProps)(Help));



// WEBPACK FOOTER //
// ./src/components/Help/Help.jsx